import { getCookie, setCookie } from './cookie';

export type TI18nCookieData = {
  country: string;
  language: string;
  languageIso2: string;
  market: string;
  region: string;
};

export function getI18nCookieData(): TI18nCookieData {
  const cookieValue = getCookie('i18n') || '||0||';
  const parts = cookieValue.split('|');
  return {
    country: parts[1],
    language: parts[2],
    languageIso2: parts[3],
    market: parts[4],
    region: parts[0],
  };
}

export function setI18nCookieData(data: TI18nCookieData): void {
  const cookieValue = `${data.region || ''}|${data.country || ''}|${data.language || ''}|${data.languageIso2 || ''}|${data.market || ''}`;
  setCookie('i18n', cookieValue, 182);
}
